import { AfterViewInit, Component, ElementRef, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';

declare const Swiper: any;

@Component({
  selector: 'app-swiper',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="swiper h-full" #swiperContainer>
      <div class="swiper-wrapper h-full">
        <ng-content></ng-content>
      </div>
    </div>
  `,
})
export class SwiperStandaloneComponent implements AfterViewInit {
  @ViewChild('swiperContainer') swiperRef!: ElementRef;

  ngAfterViewInit(): void {
    new Swiper(this.swiperRef.nativeElement, {
      direction: 'vertical',
      slidesPerView: 1,
      mousewheel: true,
      keyboard: { enabled: true },
      spaceBetween: 0,
    });
  }
}
